import { Button, Loader, Table } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ACTION_MESSAGES } from '@brokerage/utils/custom_hooks/useNotification';
import { AgencyContext } from '@brokerage/contexts/AgencyContext';
import { Api } from '@brokerage/utils/Api';
import { Colors } from '@itds/Theme';
import { format } from 'date-fns-tz';

export const List = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { setNotification } = useContext(AgencyContext);

  const [pagination, setPagination] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    loadLeads();
  }, [page]);

  const loadLeads = () => {
    setLoading(true);

    Api.loadLeads({ agency_id: params.agency_id, page }).then(({ headers, data }) => {
      setData(data);
      setPagination(JSON.parse(headers['x-pagination']));
      setLoading(false);
    });
  };

  const toggleArchive = (lead, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    Api.updateLeads(lead.id, { is_archived: !lead.is_archived })
      .then(() => {
        loadLeads();
        setNotification(ACTION_MESSAGES.AGENCIES.LEAD.ARCHIVE(!lead.is_archived));
      })
      .catch(error => {
        const data = error.response?.data;

        const message = data ? data.error : [error.message];

        setNotification(ACTION_MESSAGES.DEFAULT_ERROR_WITH_DETAILS(message));
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Table
        apiPagination={{ ...pagination, current_page: page, onClick: setPage }}
        columns={[
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'first_name',
            label: 'First Name'
          },
          {
            id: 'last_name',
            label: 'Last Name'
          },
          {
            id: 'email',
            label: 'Email'
          },
          {
            id: 'quote_id',
            label: 'Has Quote',
            render: lead =>
              lead.quote_id ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              ) : null,
            styles: { textAlign: 'center' }
          },
          {
            id: 'created_at',
            label: 'Created Date',
            render: lead => format(new Date(lead.created_at), 'MMM do, yyyy @ h:mm aaa z')
          },
          {
            id: 'crm',
            render: lead => {
              return <>{lead.crm}</>;
            }
          },
          {
            id: 'actions',
            render: lead => {
              return (
                <Button
                  color={lead.is_archived ? null : 'RED'}
                  inline={true}
                  onClick={toggleArchive.bind(null, lead)}
                  small={true}
                >
                  {lead.is_archived ? 'Unarchive' : 'Archive'}
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={data}
        onRowClick={lead => navigate(`${lead.id}`)}
        placeholder="This agency doesn't have any Leads"
      />
    </>
  );
};
